import { useQuery } from '@apollo/client';
import { gql } from 'graphql-tag';

export const RESOURCE_USER_TASK_ASSIGNMENT_SUMMARY_QUERY = gql`
  query resourceUserTaskAssignmentSummary(
    $input: ResourceUserTaskAssignmentSummaryInput!
    $includeTaskResourceUserCostProgressSummary: Boolean!
  ) {
    resourceUserTaskAssignmentSummary(input: $input) {
      taskId
      userId
      resourceEstimate {
        estimateId
        initialEstimatedHours
        initialEstimatedCost {
          amount
          currency {
            id
            displayText
          }
        }
        projectRole {
          id
          displayText
        }
      }
      taskResourceUserAllocation {
        id
        taskUri
        projectUri
        roleUri
        startDate
        endDate
        scheduleRules {
          dateRange {
            startDate
            endDate
          }
          do
        }
        totalHours
      }
      taskResourceUserHoursProgressSummary {
        actualHours
        estimatedAtCompletionHours
        estimatedRemainingHours
      }
      taskResourceUserCostProgressSummary
        @include(if: $includeTaskResourceUserCostProgressSummary) {
        actualCost {
          amount
          currency {
            symbol
          }
        }
        estimatedAtCompletionCost {
          amount
          currency {
            symbol
          }
        }
        estimatedRemainingCost {
          amount
          currency {
            symbol
          }
        }
      }
    }
  }
`;

export const useResourceUserTaskAssignmentSummary = ({
  userId,
  projectId,
  taskId,
  includeTaskResourceUserCostProgressSummary = false
}) => {
  const { loading, data } = useQuery(
    RESOURCE_USER_TASK_ASSIGNMENT_SUMMARY_QUERY,
    {
      fetchPolicy: 'cache-and-network',
      variables: {
        input: {
          userId,
          projectId,
          taskId
        },
        includeTaskResourceUserCostProgressSummary
      }
    }
  );

  return {
    loading,
    taskAssignmentSummary: data
  };
};
